import { useContext } from "react"

import { PointerPositionContext } from "shared/context/drag-and-drop/PointerPositionContext"

/**
 * Hook to access a function that returns the current pointer position.
 * Call the function in callbacks to get position without causing re-renders.
 * Returns null when not dragging.
 *
 * @example
 * const { getPointerPosition } = usePointerPosition()
 *
 * useDndMonitor({
 *   onDragMove: () => {
 *     const pos = getPointerPosition()
 *     if (pos) {
 *       console.log(pos.x, pos.y)
 *     }
 *   }
 * })
 */
export function usePointerPosition() {
  return useContext(PointerPositionContext)
}
